import React, { useState, useEffect } from 'react';
import { CheckCircle, Server, Zap, Shield, TrendingUp, Clock, Globe, ChevronLeft, ChevronRight } from 'lucide-react';
import { getStorageUrl } from '../utils/imageUrlUpdater';

const VPSForex: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentGallerySlide, setCurrentGallerySlide] = useState(0);

  // Set page title and canonical URL
  useEffect(() => {
    document.title = 'VPS Forex - VMon Cloud';
    
    // Set canonical URL
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = 'https://vmon.vn/vps-forex';
    document.head.appendChild(canonical);
    
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
      document.title = 'VMon Cloud - Dịch vụ VPS và Hosting chất lượng cao';
    };
  }, []);

  const plans = [
    {
      name: 'Forex - 2 GB - 2 CPU',
      price: '175,000',
      originalPrice: '250,000',
      cpu: '2 VCpu',
      ram: '2GB',
      storage: '30GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      latency: '< 0.5ms',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    },
    {
      name: 'Forex - 4 GB',
      price: '315,000',
      originalPrice: '415,000',
      cpu: '2 VCpu',
      ram: '4GB',
      storage: '60GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      latency: '< 0.3ms',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'Forex - 8 GB',
      price: '575,000',
      originalPrice: '800,000',
      cpu: '4 VCpu',
      ram: '8GB',
      storage: '100GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      latency: '< 0.2ms',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: true
    },
    {
      name: 'Forex - 16 GB',
      price: '915,000',
      originalPrice: '1,500,000',
      cpu: '8 VCpu',
      ram: '16GB',
      storage: '180GB SSD NVMe',
      bandwidth: 'Không giới hạn',
      latency: '< 0.1ms',
      features: ['1Gbps Ethernet Port', 'Root Access', 'Free Backup', '99.9% Uptime'],
      popular: false
    }
  ];

  const additionalPricing = [
    { item: '1 IP', price: '50,000 VNĐ / Tháng' },
    { item: '1 VCpu', price: '50,000 VNĐ / Tháng' },
    { item: '1 GB Ram', price: '50,000 VNĐ / Tháng' },
    { item: '10GB ổ cứng SSD NVMe', price: '30,000 VNĐ / Tháng' }
  ];

  const advantages = [
    {
      icon: Server,
      title: 'CHẠY BOT EA MT4, MT5 24/7 VỚI TỐC ĐỘ CAO',
      description: 'Với VPS FOREX, bot forex có thể chạy với tốc độ cao hơn so với máy tính cá nhân của bạn và có thể hoạt động liên tục 24/7. Điều này giúp bạn không bỏ lỡ bất kỳ cơ hội giao dịch nào và tăng khả năng đầu tư hiệu quả.'
    },
    {
      icon: Zap,
      title: 'HOẠT ĐỘNG VỚI ĐỘ TRỄ THẤP',
      description: 'FOREX VPS giúp cho bot EA của bạn hoạt động với độ trễ thấp, giảm thiểu thời gian chờ đợi và đảm bảo thực hiện lệnh giao dịch chính xác và nhanh chóng.'
    },
    {
      icon: Shield,
      title: 'AN TOÀN, BẢO MẬT',
      description: 'Đảm bảo về bảo mật, vì bot EA của bạn sẽ được đặt trên một môi trường bảo mật, cách ly và an toàn hơn so với máy tính cá nhân.'
    },
    {
      icon: Globe,
      title: 'ỔN ĐỊNH KẾT NỐI INTERNET',
      description: 'Khi sử dụng VPS FOREX, bạn không cần phải lo lắng về sự cố kết nối internet, vì VPS được kết nối với internet bằng các kết nối tốc độ cao và ổn định.'
    }
  ];

  const benefits = [
    {
      icon: Server,
      title: 'NÂNG CẤP TÀI NGUYÊN LINH HOẠT',
      description: 'Bạn hoàn toàn có thể chủ động nâng cấp tài nguyên RAM/CPU/SSD cho VPS của mình thông qua Trang quản lý với đầy đủ tính năng.'
    },
    {
      icon: Shield,
      title: 'HOÀN TIỀN 100% NẾU KHÔNG HÀI LÒNG',
      description: 'Trong 7 ngày đầu sử dụng, nếu bạn không hài lòng vì bất cứ lý do gì, VMon Cloud cam kết hoàn tiền 100% cho bạn.'
    },
    {
      icon: Zap,
      title: 'BĂNG THÔNG TỐC ĐỘ CAO LÊN TỚI 1GBPS',
      description: 'Cùng trải nghiệm dòng VPS mượt mà với băng thông không giới hạn lên tới 1Gbps, giúp bạn thực hiện các giao dịch nhanh chóng và an toàn.'
    },
    {
      icon: TrendingUp,
      title: 'PHẦN CỨNG MẠNH MẼ',
      description: 'Tất cả VPS tại VMon Cloud sử dụng 100% ổ cứng NVMe mạnh mẽ, kết hợp bộ xử lý thế hệ mới CPU V4 xử lý nhiều lệnh cùng lúc, giúp khách hàng những trải nghiệm tốt nhất.'
    }
  ];

  const faqItems = [
    {
      question: 'VPS Forex là gì?',
      answer: 'VPS Forex cho phép giao dịch ngoại hối nhanh chóng và ổn định hơn bằng cách sử dụng máy chủ ảo từ xa. Nhờ sử dụng VPS, các nhà giao dịch không lo mất kết nối hoặc giảm tốc độ truyền tải dữ liệu, giúp họ tập trung vào phân tích thị trường và đưa ra quyết định giao dịch.'
    },
    {
      question: 'Tôi nên chọn VPS nước nào để chạy bot Forex?',
      answer: 'Việc chọn địa điểm VPS để chạy forex phụ thuộc vào nhiều yếu tố khác nhau, VPS càng gần địa điểm mà bạn muốn giao dịch forex, thì tốc độ kết nối càng nhanh. - Nếu bạn muốn kết nối với các nhà môi giới ngoại hối đặt trụ sở tại Mỹ, bạn có thể chọn VPS Mỹ để đạt được tốc độ và độ ổn định cao. - Đối với châu Âu, VPS Anh thường được sử dụng để chạy forex. - Đối với châu Á, VPS Singapore thường được sử dụng để chạy forex giúp kết nối Internet ổn định.'
    },
    {
      question: 'Tôi mới sử dụng VPS lần đầu tôi nên làm gì?',
      answer: 'Bạn có thể tham khảo bài viết: Hướng Dẫn Sử Dụng VPS Windows Với Remote Desktop Chi Tiết Nhất để bắt đầu sử dụng vps. Bạn có thể tìm hiểu thêm nhiều thông tin các bài viết của chúng tôi về vps tại: https://vmon.vn/category/vps-windows'
    },
    {
      question: 'Tôi có thể sử dụng VPS để chạy nhiều bot forex cùng một lúc không?',
      answer: 'Câu trả lời là CÓ. Với VPS, bạn có thể cài đặt và chạy nhiều phần mềm MT4 trên cùng một máy ảo, giúp bạn quản lý nhiều tài khoản forex và bot khác nhau một cách thuận tiện hơn. Tuy nhiên, bạn cần lưu ý rằng việc chạy nhiều bot trên cùng một VPS sẽ tốn nhiều tài nguyên hơn, do đó, bạn cần chọn VPS với dung lượng và cấu hình phù hợp để đảm bảo bot chạy mượt mà và hiệu quả.'
    },
    {
      question: 'Cấu hình VPS cần những thông số gì để chạy bot forex mượt?',
      answer: 'Để chạy bot forex mượt trên VPS, bạn cần chọn cấu hình phù hợp với các yêu cầu của bot và số lượng tài khoản cần chạy, dưới đây là những thông số bạn cần lưu ý: - Dung lượng RAM: Các bot forex có thể tốn rất nhiều RAM, do đó, bạn nên chọn VPS có ít nhất 2 GB RAM để đảm bảo chạy mượt mà. - Số lượng CPU: Bot forex cần xử lý nhiều tác vụ tính toán, do đó, bạn nên chọn VPS có ít nhất 2 CPU. - Ổ cứng: Bạn nên chọn VPS có đủ dung lượng ổ cứng để lưu trữ dữ liệu của bot forex. - Hệ điều hành: Bạn nên chọn VPS với hệ điều hành phù hợp với bot forex, thường là Windows Server hoặc Linux.'
    },
    {
      question: 'Tôi có thể cài đặt MT4 trên VPS để chạy bot forex không?',
      answer: 'Có, bạn có thể cài đặt MT4 trên VPS để chạy bot forex. Việc cài đặt MT4 trên VPS giúp bạn có thể quản lý tài khoản forex và chạy bot một cách thuận tiện hơn. Tuy nhiên, bạn nên lưu ý chọn cấu hình VPS có đủ tài nguyên và khả năng xử lý để đáp ứng yêu cầu của bot và MT4: - CPU: Chọn VPS có CPU có tốc độ cao và đủ mạnh để xử lý các giao dịch của bot, VMon Cloud khuyến khích bạn dùng VPS có ít nhất 2 CPU. - RAM: Bot MT4 yêu cầu một lượng RAM đủ lớn để chạy một cách ổn định. Bạn nên chọn VPS có RAM từ 4GB trở lên. - Ổ cứng: Cài đặt MT4 và lưu trữ dữ liệu giao dịch đòi hỏi một lượng lớn không gian lưu trữ. Nên chọn VPS có dung lượng ổ cứng đủ lớn để lưu trữ dữ liệu của bot và MT4. - Hệ điều hành: Vì MT4 phổ biến sử dụng trên hệ điều hành Windows, nên chọn VPS sử dụng hệ điều hành Windows để chạy MT4.'
    },
    {
      question: 'VPS forex có dùng IP chung hay riêng?',
      answer: 'Tại VMon Cloud, tất cả các VPS đều sử dụng IP riêng.'
    }
  ];

  const testimonials = [
    getStorageUrl('feedback/feedback_1.jpg'),
    getStorageUrl('feedback/feedback_2.jpg'),
    getStorageUrl('feedback/feedback_3.jpg'),
    getStorageUrl('feedback/feedback_4.jpg'),
    getStorageUrl('feedback/feedback_5.jpg'),
    getStorageUrl('feedback/feedback12.jpg'),
    getStorageUrl('feedback/feedback16.jpg'),
    getStorageUrl('feedback/feedback17.jpg')
  ];

  const galleryImages = [
    {
      src: getStorageUrl('panel/Quan-ly-vps.PNG'),
      title: "Quản Lý VPS",
      description: "Quản lý các thông tin vps đầy đủ và tiện lợi."
    },
    {
      src: getStorageUrl('panel/View-VNC.PNG'),
      title: "View VPS qua VNC",
      description: "Truy cập xử lý sự cố vps thông qua VNC."
    },
    {
      src: getStorageUrl('panel/lich-su-so-du.PNG'),
      title: "Số Dư Tài Khoản",
      description: "Việc quản lý số dư tài khoản trở nên thuận tiện và minh bạch hơn."
    },
    {
      src: getStorageUrl('panel/Mua-VPS.PNG'),
      title: "MUA VPS",
      description: "Bạn có thể dễ dàng mua VPS Singapore thông qua giao diện \"one click\"."
    },
    {
      src: getStorageUrl('panel/giao-dien-mobile.PNG'),
      title: "Giao Diện Mobile",
      description: "Giao diện trên thiết bị di động thân thiện và dễ dàng quản lý."
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev + 1) % galleryImages.length);
  };

  const prevGallerySlide = () => {
    setCurrentGallerySlide((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <TrendingUp className="h-8 w-8 mr-2" />
              <span className="text-2xl font-semibold">VPS Forex Trading</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              VPS Forex
            </h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Thuê VPS Forex chạy bot MT4, MT5 tốc độ cao, sao lưu dữ liệu tự động, an toàn, bảo mật.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Zap className="h-4 w-4 mr-2" />
                Ultra Low Latency
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Clock className="h-4 w-4 mr-2" />
                24/7 Trading
              </div>
              <div className="flex items-center bg-blue-500 bg-opacity-50 px-4 py-2 rounded-full">
                <Shield className="h-4 w-4 mr-2" />
                99.99% Uptime
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">BẢNG GIÁ VPS FOREX</h2>
            </div>
          {/* Alert */}
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-8 rounded">
            <p className="font-bold">Ưu đãi hấp dẫn giảm ngay 40% khi gia hạn 3 năm.</p>
            <p>Giảm 20% khi gia hạn 1 năm, giảm 10% khi gia hạn 6 tháng, giảm 5% khi gia hạn 3 tháng.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {plans.map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.popular ? 'ring-2 ring-blue-500' : ''
                }`}
              >
                {plan.popular && (
                  <div className="bg-blue-500 text-white text-center py-2 font-semibold">
                    BÁN CHẠY
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <div className="mb-4">
                    <div className="flex items-baseline">
                      <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                      <span className="text-gray-600 ml-1"> VNĐ/Tháng</span>
                    </div>
                    <div className="text-sm text-gray-500 line-through">{plan.originalPrice} VNĐ</div>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex justify-between">
                      <span className="text-gray-600">CPU:</span>
                      <span className="font-semibold">{plan.cpu}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RAM:</span>
                      <span className="font-semibold">{plan.ram}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Storage:</span>
                      <span className="font-semibold">{plan.storage}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Bandwidth:</span>
                      <span className="font-semibold">{plan.bandwidth}</span>
                    </div>
                    <div className="text-center bg-blue-50 p-2 rounded">
                      <span className="text-sm font-medium text-blue-700">Latency: {plan.latency}</span>
                    </div>
                  </div>

                  <ul className="space-y-2 mb-6">
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm">
                        <CheckCircle className="h-4 w-4 text-green-500 mr-2 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <a 
                    href="https://cloud.vmon.vn/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-full py-3 rounded-lg font-semibold transition-colors flex items-center justify-center ${
                      plan.popular
                        ? 'bg-blue-600 text-white hover:bg-blue-700'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                  >
                    Đăng Ký
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Additional Pricing */}
          <div className="mt-12 bg-white rounded-lg shadow-lg p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Bảng Giá Đăng Ký Thêm CPU, RAM, Ổ Cứng, IP
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {additionalPricing.map((item, index) => (
                <div key={index} className="text-center p-4 border border-gray-200 rounded-lg">
                  <div className="flex items-center justify-center mb-2">
                    <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                    <span className="font-semibold text-gray-900">{item.item}</span>
                  </div>
                  <p className="text-blue-600 font-medium">{item.price}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              TẠI SAO NÊN THUÊ FOREX VPS TẠI VMON CLOUD?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((advantage, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <advantage.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{advantage.title}</h3>
                <p className="text-gray-600 text-sm">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              LỢI ÍCH KHI THUÊ VPS FOREX GIÁ RẺ TẠI VMON CLOUD
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <benefit.icon className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 text-sm">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Customer Feedback Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">KHÁCH HÀNG NÓI GÌ VỀ CHÚNG TÔI?</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Tại VMon Cloud, ý kiến của khách hàng luôn được đặt lên hàng đầu và chúng tôi cam kết lắng nghe và tiếp thu mọi phản hồi để cải thiện chất lượng sản phẩm và dịch vụ. Chính nhờ điều này, chúng tôi sẽ luôn đáp ứng tốt hơn nhu cầu và mong muốn của khách hàng.
            </p>
          </div>

          {/* Testimonial Slider */}
          <div className="relative max-w-4xl mx-auto">
            {/* Main Slider */}
            <div className="relative overflow-hidden rounded-lg shadow-lg bg-white">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="w-full flex-shrink-0 flex justify-center items-center p-4">
                    <img
                      src={testimonial}
                      alt={`Customer Feedback ${index + 1}`}
                      className="max-w-full max-h-96 object-contain rounded-lg shadow-sm"
                    />
                  </div>
                ))}
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronLeft className="h-6 w-6 text-gray-700" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all duration-200"
              >
                <ChevronRight className="h-6 w-6 text-gray-700" />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-200 ${
                    index === currentSlide 
                      ? 'bg-blue-600 scale-110' 
                      : 'bg-gray-300 hover:bg-gray-400'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Thư Viện Hình Ảnh</h2>
          <p className="text-lg text-gray-600 mb-12 text-center">
            Việc quản lý tài khoản, tạo mới và giám sát VPS trở nên dễ dàng hơn bao giờ hết với trang Panel hiện đại, thân thiện và dễ sử dụng.
          </p>
          
          {/* Gallery Slider */}
          <div className="relative max-w-4xl mx-auto">
            <div className="overflow-hidden rounded-lg bg-gray-100">
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentGallerySlide * 100}%)` }}
              >
                {galleryImages.map((image, index) => (
                  <div key={index} className="w-full flex-shrink-0 p-8">
                    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                      <img
                        src={image.src}
                        alt={image.title}
                        className="w-full h-64 object-contain bg-gray-50"
                      />
                      <div className="p-6 text-center">
                        <h3 className="text-xl font-semibold text-gray-900 mb-2">{image.title}</h3>
                        <p className="text-gray-600">{image.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Navigation Buttons */}
            <button
              onClick={prevGallerySlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronLeft className="h-6 w-6 text-gray-600" />
            </button>
            <button
              onClick={nextGallerySlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 shadow-lg transition-all"
            >
              <ChevronRight className="h-6 w-6 text-gray-600" />
            </button>
            
            {/* Dots Indicator */}
            <div className="flex justify-center mt-6 space-x-2">
              {galleryImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentGallerySlide(index)}
                  className={`w-3 h-3 rounded-full transition-colors ${
                    index === currentGallerySlide ? 'bg-blue-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              NHỮNG CÂU HỎI THƯỜNG GẶP VỀ VPS TRADING SERVER
            </h2>
          </div>

          <div className="space-y-4">
            {faqItems.map((item, index) => (
              <details key={index} className="bg-white rounded-lg p-6 shadow">
                <summary className="font-semibold text-gray-900 cursor-pointer hover:text-blue-600">
                  {item.question}
                </summary>
                <p className="mt-4 text-gray-600">{item.answer}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Cùng nhau, Trực tuyến.
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Chúng tôi ở đây giúp các bạn có thể làm việc online một cách hiệu quả nhất.
          </p>
          <a 
            href="https://cloud.vmon.vn/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-colors inline-block"
          >
            Bắt đầu ngay
          </a>
        </div>
      </section>
    </div>
  );
};

export default VPSForex;